import { render, staticRenderFns } from "./right-configuration.vue?vue&type=template&id=d62085ac&scoped=true"
import script from "./right-configuration.vue?vue&type=script&lang=js"
export * from "./right-configuration.vue?vue&type=script&lang=js"
import style0 from "./right-configuration.vue?vue&type=style&index=0&id=d62085ac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62085ac",
  null
  
)

export default component.exports